import React from 'react'

import { CopyButton } from '@components/common/CopyButton'
import { ButtonClean, ConfirmModal, Icon, Loading, useModalContext } from '@fourthwall/components'
import { SpotifyIcon } from '@fourthwall/icons'

import * as S from './SyncedBar.styled'

type SyncedBarProps = {
  url: string
  errored?: boolean
  loading?: boolean
  onClick: () => void
}

export const SyncedBar = ({ url, errored, loading, onClick }: SyncedBarProps) => {
  const modal = useModalContext()

  return (
    <div style={{ width: '100%' }}>
      <Loading isLoading={loading}>
        <S.Container>
          <S.IconContainer>
            <Icon component={SpotifyIcon} height={20} />
          </S.IconContainer>
          <div>
            <S.Status>
              <S.Title>{errored ? 'Sync failed' : 'Synced to Spotify'}</S.Title>
              <ButtonClean
                label="Disconnect"
                withUnderline
                onClick={() => {
                  modal.open(ConfirmModal, {
                    title: 'Disconnect from Spotify?',
                    text: 'Your podcast be removed from Spotify and it will no longer be synced.  ',
                    confirmLabel: 'Disconnect',
                    confirmAppearance: 'destructive',
                    onConfirm: onClick,
                  })
                }}
              />
            </S.Status>
            <S.CopyWrapper>
              <CopyButton
                appearance="secondary"
                href={url}
                label={url}
                copyLabel="Copy link"
                copyText={url}
              />
            </S.CopyWrapper>
          </div>
        </S.Container>
      </Loading>
    </div>
  )
}
